import enTranslation from "../public/locales/en/blog.json";
import deTranslation from "../public/locales/de/blog.json";
import esTranslation from "../public/locales/es/blog.json";
import frTranslation from "../public/locales/fr/blog.json";
import idTranslation from "../public/locales/id/blog.json";
import itTranslation from "../public/locales/it/blog.json";
import ptTranslation from "../public/locales/pt/blog.json";
import ruTranslation from "../public/locales/ru/blog.json";
import trTranslation from "../public/locales/tr/blog.json";

export const getTranslation = (locale, key) => {
  const translations = {
    en: enTranslation,
    de: deTranslation,
    es: esTranslation,
    fr: frTranslation,
    id: idTranslation,
    it: itTranslation,
    pt: ptTranslation,
    ru: ruTranslation,
    tr: trTranslation,
  };

  return translations[locale][key]
}
